/*
 * This file provides the entrance points for php to the javascript components
 */
import {CommandCaller} from "../../lib/commands";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Redux from "redux";
import thunkMiddleware from 'redux-thunk'

import * as Msgs from './messageTypes'

import {DatePickerProps} from '../../lib/sbhtml/datePicker'

import { EmploymentHistoryPositionState, EmploymentHistoryContainer, FieldLabels as UIFieldLabels } from './containers'
import { reducer } from './reducers/reducers'

export type EmploymentHistoryCommandProps = {
	ajaxPageUrl: string,
	datePickerProps: DatePickerProps
}

/* 
 * something to represent the table (the data grid)
 */
class EmploymentHistory {
	data:Msgs.EmploymentHistoryData;
	dataGridId: string

	public constructor(data:Msgs.EmploymentHistoryData, dataGridId: string) {
		this.data = data
		this.dataGridId = dataGridId
	}

	getData = () => this.data
	getRow = (rowId:number) => this.data[rowId]
	getId = () => this.dataGridId
}

var employmentHistory:EmploymentHistory

let companies: Msgs.Companies
let fieldLabels: Msgs.FieldLabels

const mapFieldLabels = (serverFieldLabels: Msgs.FieldLabels): UIFieldLabels => {
	return serverFieldLabels // works as UIFieldLabels is a structure type which is a subset of FieldLabels
}

export namespace admin {
	
	// refresh grid getting data from server after any server update (and close of modal edit dialog)
	const refreshEmploymentHistoryList = () => {
		new HtmlDataGrid(employmentHistory.getId()).refresh();
	}

	/*
	 * To attach to the data grid dataFunction.  Provides the callback function to request the employment history list
	 * from the server.  It is called on initial display and on every refresh
	 */
	export const getEmploymentHistoryGridData = (props:EmploymentHistoryCommandProps, dataGridId: string, userId: number) => {
		return (callback:(_:string) => void) => {
			const cc = new CommandCaller(props.ajaxPageUrl);
			(cc.runGet(
				'getEmploymentHistoryList',
				{   dataGridId: dataGridId,
					userId:     userId
				}
			) as Promise<Msgs.GetEmploymentHistoryGridDataResponse>).then(
				(response) => {
					employmentHistory = new EmploymentHistory(response.data, dataGridId)
					companies = response.companies
					fieldLabels = response.labels
					callback(response.content)
				}
			)
		}
	}

	export const getInitialState = (rowId: number, isNew: boolean):EmploymentHistoryPositionState => {
		if (isNew) {
			let props = employmentHistory.getRow(-1);
			return {
				id: 0,
				userId: props.userId,
				startDate: '',
				endDate: '',
				companyName: '',
				companyId: 0,
				positionTitle: '',
				isSaving: false
			}
		}
		
		let props = employmentHistory.getRow(rowId);
		return {
			id: props.id,
			userId: props.userId,
			startDate: props.startDate,
			endDate: props.endDate,
			companyName: props.companyName,
			companyId: props.companyId,
			positionTitle: props.positionTitle,
			isSaving: false
		}
	}
	export const showEmploymentHistoryPositionModal = (commandProps: EmploymentHistoryCommandProps, rowId: number, isNew: boolean) => {
		const div = document.createElement('div');
		const body = document.getElementsByTagName('body')[0];
		body.appendChild(div);

		const initialState = getInitialState(rowId, isNew)
		
		const store = Redux.createStore(
			reducer,
			initialState,
			Redux.applyMiddleware(thunkMiddleware)
		)

		ReactDOM.render(
			<EmploymentHistoryContainer 
				store={store}
				companies={companies}
				fieldLabels={mapFieldLabels(fieldLabels)}
				ajaxPageUrl={commandProps.ajaxPageUrl}
				datePickerProps={commandProps.datePickerProps}
				onClose={() => {
					ReactDOM.unmountComponentAtNode(div)
					refreshEmploymentHistoryList()
				}}
		/>, div)
	}

	export const deletePositions = (commandProps: EmploymentHistoryCommandProps, rowIds: number[]) => {
		const cc = new CommandCaller(commandProps.ajaxPageUrl);
		(cc.runPost('deleteEmploymentHistoryPositions',{ids: rowIds, userId: employmentHistory.getRow(-1).userId}) as Promise<Msgs.DeletePositionsResponse>).then(
			(response) => {
				refreshEmploymentHistoryList()
				if(response.content.length) {
					alert(response.content.join("\n"))
				}
			}
		)
	}
}



// WEBPACK FOOTER //
// ./src/contacts/employmentHistory/index.tsx